import React from 'react';
import { fmtMoney } from '../utils/money';

const emptyRow = { name: '', unit: '', quantity: 1, unit_price: '' };

// محرّر قائمة الخدمات المسعّرة لمشروع — قيمة مضبوطة عبر value/onChange.
export default function ServicesEditor({ value = [], onChange }) {
  const rows = value;

  const update = (i, key, val) => {
    onChange(rows.map((r, idx) => (idx === i ? { ...r, [key]: val } : r)));
  };
  const addRow = () => onChange([...rows, { ...emptyRow }]);
  const removeRow = (i) => onChange(rows.filter((_, idx) => idx !== i));

  const lineTotal = (r) => (Number(r.quantity) || 0) * (Number(r.unit_price) || 0);
  const total = rows.reduce((sum, r) => sum + lineTotal(r), 0);

  return (
    <div>
      {rows.length === 0 ? (
        <div style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 8 }}>
          لا توجد خدمات بعد. أضف خدمة وحدّد سعرها لتُحتسب في الفاتورة.
        </div>
      ) : (
        <div className="table-wrap" style={{ marginBottom: 8 }}>
          <table>
            <thead>
              <tr>
                <th style={{ minWidth: 160 }}>الخدمة</th>
                <th style={{ width: 90 }}>الوحدة</th>
                <th style={{ width: 80 }}>الكمية</th>
                <th style={{ width: 110 }}>سعر الوحدة</th>
                <th style={{ width: 110 }}>الإجمالي</th>
                <th style={{ width: 40 }}></th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={i}>
                  <td>
                    <input className="form-input" value={r.name}
                      placeholder="اسم الخدمة"
                      onChange={e => update(i, 'name', e.target.value)} />
                  </td>
                  <td>
                    <input className="form-input" value={r.unit || ''}
                      placeholder="ساعة، صفحة…"
                      onChange={e => update(i, 'unit', e.target.value)} />
                  </td>
                  <td>
                    <input className="form-input" type="number" min="0" step="0.01" value={r.quantity}
                      onChange={e => update(i, 'quantity', e.target.value)} />
                  </td>
                  <td>
                    <input className="form-input" type="number" min="0" step="0.01" value={r.unit_price}
                      onChange={e => update(i, 'unit_price', e.target.value)} />
                  </td>
                  <td style={{ whiteSpace: 'nowrap' }}>{fmtMoney(lineTotal(r))}</td>
                  <td>
                    <button type="button" className="btn btn-sm btn-outline"
                      style={{ color: 'var(--danger)' }}
                      onClick={() => removeRow(i)} title="حذف">✕</button>
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={4} style={{ textAlign: 'left', fontWeight: 600 }}>الإجمالي</td>
                <td style={{ fontWeight: 600, whiteSpace: 'nowrap' }}>{fmtMoney(total)} ريال</td>
                <td></td>
              </tr>
            </tfoot>
          </table>
        </div>
      )}
      <button type="button" className="btn btn-sm btn-outline" onClick={addRow}>+ إضافة خدمة</button>
    </div>
  );
}
